require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
// eslint-disable-next-line no-extend-native
Array.prototype.$$arrObjSort = function (field) {
  if (!field) return this.sort();else return this.sort(function (_this, _prev) {
    return _this[field] && !_prev[field] ? -1 : _this[field] - _prev[field];
  });
  // return this.sort((_this, _prev) => _this[field] && !_prev[field] ? -1 : _prev[field] - _this[field])
};

/** 数组排序
 * @description: 数组排序，如果是数组对象，那么可以指定浅层中哪个字段作为排序条件
 * @param { * } data 待处理数据
 * @param { String } order 升序还是降序，默认降序，[ desc - 降序, asc - 升序 ]
 * @param { Boolean } nullSort 排序条件字段为空是否参与排序，如果不参与则放在最末尾
//  * @return { Array } 返回数据
 */
// eslint-disable-next-line no-extend-native
Array.prototype.$$sort = function /* field, order, nullSort = true */
() {
  var _a$;
  var a = Array.prototype.slice.call(arguments);
  var field = a[0];
  var order = a[1] === 'desc' || a[1] === 'asc' ? a[1] : '';
  var nullSort = (_a$ = a[2]) !== null && _a$ !== void 0 ? _a$ : true;
  if (!field) return this.sort();else {
    return this.sort(function (_this, _prev) {
      var aa = _this[field];
      var bb = _prev[field];
      switch (order) {
        case 'asc':
          if (nullSort) return aa - bb;else {
            if (aa && !bb) bb = aa + 1;
            return aa - bb;
          }
        default:
          return bb - aa;
      }
    });
  }
};

/** 数组差集比较
 * @description: 获取数组的差集，并返回新的数组
 * @param { Array } 需要比较的数组
 * @param { String } fieldName 指定字段名
 * @return { Array } 返回数据
 */
// eslint-disable-next-line no-extend-native
Array.prototype.$$differenceSet = function (arr, fieldName) {
  if (Array.isArray(arr)) {
    try {
      var a = arr.map(function (item) {
        return fieldName ? item[fieldName] : JSON.stringify(item);
      });
      return this.filter(function (item) {
        return !a.includes(fieldName ? item[fieldName] : JSON.stringify(item));
      });
    } catch (e) {
      console.error(e);
    }
  }
  return this;
};

/** 数组差集比较
 * @description: 获取数组的差集，并返回新的数组
 * @param { Array } 需要比较的数组
 * @param { String | Function } fieldName 指定字段名
 * @return { Array } 返回数据
 */
// eslint-disable-next-line no-extend-native
Array.prototype.$$differenceSet = function (arr, fieldName) {
  if (Array.isArray(arr)) {
    try {
      var a = arr.map(function (item) {
        return fieldName ? item[fieldName] : JSON.stringify(item);
      });
      if (typeof fieldName === 'function') return this.filter(function (item) {
        return fieldName(item);
      });
      return this.filter(function (item) {
        return !a.includes(fieldName ? item[fieldName] : JSON.stringify(item));
      });
    } catch (e) {
      console.error(e);
    }
  }
  return [];
};

/** 数组交集比较
 * @description: 获取数组的交集，并返回新的数组
 * @param { Array } 需要比较的数组
 * @param { String | Function } fieldName 指定字段名
 * @return { Array } 返回数据
 */
// eslint-disable-next-line no-extend-native
Array.prototype.$$intersection = function (arr, fieldName) {
  if (Array.isArray(arr)) {
    try {
      var a = arr.map(function (item) {
        return fieldName ? item[fieldName] : JSON.stringify(item);
      });
      if (typeof fieldName === 'function') return this.filter(function (item) {
        return fieldName(item, a);
      });
      return this.filter(function (item) {
        return a.includes(fieldName ? item[fieldName] : JSON.stringify(item));
      });
    } catch (e) {
      console.error(e);
    }
  }
  return [];
};